module.exports = __webpack_public_path__ + "img/favoris-icon-white-full.31555b89.svg";